import { $ } from '@/Engine/state';
import { caseComponents, tParentAccessory } from '@/Interfaces/caseComponentsLib';
import { Part } from '@/Engine/Part';
import { childrenAccessoryWithoutAccessory, setActualParentChildren } from '@/Engine/eventHandlers/libs/shieldChildrenAccessoryParent';
import { shelfCNCHard } from '@/Engine/shelfCNCHard';
import { setRedMark } from '@/Engine/eventHandlers/libs/getHardSection';

export function markAllCollision() {
    if (!$.toolChest) return;
    const activeComponent = $.selectedModel?.userData?.parent;
    if (activeComponent && activeComponent.key === 'accessory') {
        let parentKeys: tParentAccessory[];
        // пересчет родителя - родитель меняется только для выбранного аксессуара
        // аксессуар становится на приоритетный экрна из пересекаемых
        if (activeComponent.model.name.includes('plastic_box')) {
            parentKeys = [ 'shield', 'shelf' ];
        } else {
            parentKeys = [ 'shield' ];
        }
        childrenAccessoryWithoutAccessory(activeComponent, parentKeys);
        setActualParentChildren(activeComponent, parentKeys);
    }
    $.toolChest.accessory?.forEach(accessory => {
        isParentForAccessory(accessory);
        markCollisionForObject(accessory);
    });

    $.toolChest.separator?.forEach(separator => markCollisionForObject(separator));
    $.toolChest.separatorT?.forEach(separatorT => markCollisionForObject(separatorT));
    $.toolChest.drawer?.forEach(drawer => markCollisionForObject(drawer));
    $.toolChest.shelfCNC?.forEach(shelfCNC => markCollisionForObject(shelfCNC));
    $.toolChest.shield?.forEach(shield => markCollisionForObject(shield));
    $.toolChest.shelfCNCHard?.forEach(shelfCNCHard => getShelveCNCHardCollisionForObject(shelfCNCHard));
    $.toolChest.shelf?.forEach(shelf => markCollisionForObject(shelf));
}

//устанавливаем аксессуары только на экран - иначе коллизия
export function isParentForAccessory(accessory: Part) {
    if (!accessory.parentAccessory?.length) {
        accessory.redMark();
        return;
    }
    accessory.parentAccessory?.forEach(parent => {
        parent.model?.visible ? accessory.noMark() : accessory.redMark();
    });
}

export const getShelveCNCHardCollisionForObject = (object: shelfCNCHard) => {
    const res: Part[] = [];
    if (!object.obb) return;
    $.toolChest?.shelfCNCHard?.forEach((x: shelfCNCHard) => {
        if (!object?.model?.visible) return;
        if (x === object) return;
        if (!x?.obb) return;
        if (!object.obb?.intersectsOBB(x.obb)) return;
        if (object.isChild(x)) return;
        res.push(x);
       //коллизия только между разными группами(разный родитель - s1)
        //внутри группы для секций нет коллизий
        if (x.parent !== object.parent) {
            setRedMark(object?.parent);
            setRedMark(x?.parent);
            return;
        }

    });
    return res;
};

export const markCollisionForObject = (object: Part) => {
    if (!object.obb) return;
    if (!$.toolChest) return;
    $.toolChest.parts?.forEach((x: Part|shelfCNCHard) => {
        if (!object?.model?.visible) return;
        if (x === object) return;
        //исключение для широких комплектующих находящихся под полкой для Т-перегородки
        if (!checkCrossWithSeparatorT(x, object)) return;
        if (!x.obb || !object.obb?.intersectsOBB(x.obb)) return;

        //В шкафах серии TC и AMH TC возможно установить полку на уровне перф экрана (не должно загораться красным)
        // (при этом в шкафах серии HARD должно загораться красным)
        if (((object.key.includes('shelf') && x.key === 'shield') ||
            (object.key === 'shield' && x.key.includes('shelf'))) &&
            !$.toolChest?.blenderName?.includes('hard')) {
            return;
        }

        if (!setCollisionAccessoryAndParent(object, x)) return;

        if (x instanceof shelfCNCHard && x?.parent) {
            setRedMark(x?.parent);
            object.redMark();
        }
        x.redMark();
    });

};

export const setCollisionAccessoryAndParent = (object: Part|shelfCNCHard, parent: Part|shelfCNCHard) => {
    //искл коллизии между экраном или полкой и аксессуаром
    if (
        (object.model.name.includes('plastic_box') && (parent.key === 'shield' ||  parent.key === 'shelf')) ||
        (parent.model.name.includes('plastic_box') && (object.key === 'shield' || object.key === 'shelf'))
    ) {
        return false;
    }

    //искл коллизии между экраном и аксессуаром
    if ((object.key === 'accessory' && parent.key === 'shield') ||
        (object.key === 'shield' && parent.key === 'accessory')) {
        return false;
    }
    //коллизия 2х аксессураров
    if (object.key === 'accessory' && parent.key === 'accessory') {
        object.redMark();
    }
    return true;
};

//исключение для широких комплектующих находящихся под полкой для Т-перегородки
export const checkCrossWithSeparatorT = (x: Part, object: Part) => {
    if(!object.obb || !x.obb) return true;
    if (
        x.key === 'separatorT' &&
        (object.obb.center.y + object.obb.halfSize.y) < (x.obb.center.y + x.obb.halfSize.y)
    ) {
        //допустимо установить ящик малый с фасадом для шкафов TC так, чтобы фасад заходил на полку Т-перегородки
        if (x.key === 'separatorT' && object._model.name === 'drawerS_tcf_42x45') {
            object.noMark();
            x.noMark();
            return false;
        }
        if (object.isSmall) return true;
        if (object.key === 'accessory') return true;
        x.redMark();
        object.redMark();
    }
    return true;
};

export const noMarkAllCollision = () => {
    if (!$.toolChest) return;
    $.toolChest.parts?.forEach(x => x.noMark());
};


export const getCollisionForObject = (object: Part) => {
    if (!$.toolChest || !$.selectedModel) return;
    const collisionObject: any[] = [];
    caseComponents.forEach(key => {
        // @ts-ignore
        $.toolChest[key]?.forEach(x => {
            if (object.obb && x.obb && object.obb.intersectsOBB(x.obb) && x !== object) {
                collisionObject.push(x);
                x.redMark();
                return;
            }
            x.noMark();
        });
    });
    return collisionObject;
};